import {$} from '../utils';

// Horizontal Image component
const HorizontalImageSection = () => {
    // Core values details
    $('.cardItem', (trigger) => {
        trigger.addEventListener('pointerenter', () => {
            // Removing active class
            $('.cardItem').removeClass('active');
            // Getting background image
            const attr = trigger.getAttribute('data-bg');
            // Adding active class
            $(trigger).addClass('active');
            // Setting background image
            $('#itemWrapperBackground', (x) => {
                x.setAttribute('style', `background-image: url("${attr}")`);
            })
        });
    });
};

// Export component
export default HorizontalImageSection;